<div class="done-modal">
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <button
    (click)="onClickDone()"
    class="button-simple lg-20 shock-pink uppercase submit-button"
  >
    Done
  </button>
</div>
